// extracted by mini-css-extract-plugin
module.exports = {"Faq":"Faq_Faq__2Di66","Faq_title":"Faq_Faq_title__2mxg_","Faq_subtitle":"Faq_Faq_subtitle__2cRJi"};